module.exports = __webpack_public_path__ + "img/174.e3356ade.jpg";